import {createSlice} from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
    sessionId: uuidv4(),
    authToken: null,
    referralCode: null,
    generalInformation: null,
    personalInformation: null,
    address: null,
    phone: null,
    creditCheckEvaluationProcess: null,
    marketingMetadata: null,
};

const applicationProcessSlice = createSlice({
    name: 'applicationProcess',
    initialState,
    reducers: {
        updateAuthToken(state, action) {
            state.authToken = action.payload;
        },
        updateReferralCode(state, action) {
            state.referralCode = action.payload;
        },
        updateGeneralInformation(state, action) {
            state.generalInformation = action.payload;
        },
        updatePersonalInformation(state, action) {
            state.personalInformation = action.payload;
        },
        updateAddress(state, action) {
            state.address = action.payload;
        },
        updatePhone(state, action) {
            state.phone = action.payload;
        },
        updateCreditCheckEvaluationProcess(state, action) {
            state.creditCheckEvaluationProcess = action.payload;
        },
        resetApplicationProcess(state) {
            state.generalInformation = null;
            state.personalInformation = null;
            state.address = null;
            state.phone = null;
            state.creditCheckEvaluationProcess = null;
        },
        updateMarketingMetadata(state, action) {
            state.marketingMetadata = action.payload;
        },
    },
});

export const {
    updateAuthToken,
    updateReferralCode,
    updateGeneralInformation,
    updatePersonalInformation,
    updateAddress,
    updatePhone,
    updateCreditCheckEvaluationProcess,
    resetApplicationProcess,
    updateMarketingMetadata,
} = applicationProcessSlice.actions;

export default applicationProcessSlice.reducer;